module.exports = __webpack_public_path__ + "img/kaart_zuilen_hd.718fb070.jpg";